module YVR.Utilities.Cache {
	interface ICacheStore {
		data: any;
		expires: Date;
	}

	// Default options
	const options = {
		cacheKeyPrefix: 'YVR_',
		expiryTime: 5 // minutes
	};


	/**
	 * Set a key in localstorage with a cache date of 60 minutes.
	 * Adapted from: https://gist.github.com/Fluidbyte/4718380
	 * @param {String}  key        The key to be used to store the data
	 * @param {Object}  value      The value to be used against the key
	 * @param {Integer} expiryTime The length of time to keep the data, in minutes
	 */
	export function setItem(key: string, value: any, expiryTime: number): void {
		if (Modernizr.localstorage) {
			key = options.cacheKeyPrefix + key;

			// If value is detected, set new or modify store
			if (typeof value !== 'undefined' && value !== null) {
				// Set default expiry time to 1 minute
				expiryTime = expiryTime || options.expiryTime;

				// Create expiration object
				const date = new Date();
				date.setTime(date.getTime() + (expiryTime * 60 * 1000));

				const store = {
					value,
					expires: date
				};

				// Convert object values to JSON
				const item = JSON.stringify(store);

				// Set the store item
				localStorage.setItem(key, item);
			}

			// Null specified, remove store
			if (value === null) {
				localStorage.removeItem(key);
			}
		}
	}


	/**
	 * Get an item from localstorage.
	 * @param   {String}      key The key to be used to get the data
	 * @returns {Object|null}     An if cached, null if expired or empty
	 */
	export function getItem (key: string): any {
		if (Modernizr.localstorage) {
			key = options.cacheKeyPrefix + key;

			const data = localStorage.getItem(key);

			// Try to parse JSON
			try {
				const item = JSON.parse(data);

				if (new Date(item.expires) < new Date()) {
					return null;
				}

				return item.value;
			} catch (e) {
				return null;
			}
		}

		return null;
	}


	/**
	 * Removes an item from localstorage.
	 * @param {String} key The key to be used to remove the data
	 */
	export function removeItem (key: string): void {
		if (Modernizr.localstorage) {
			key = options.cacheKeyPrefix + key;
			localStorage.removeItem(key);
		}
	}

}
